import CONSTASNTS from 'utils/constants';
import _ from 'ckLodash';
import utils from 'utils/utils';

var defaultTagsStyles = {
    h1: 'font_0',
    h2: 'font_2',
    h3: 'font_3',
    h4: 'font_4',
    h5: 'font_5',
    h6: 'font_6',
    p: 'font_8',
    blockquote: 'font_8'
};
Object.defineProperty(defaultTagsStyles, 'tagsRegexStr', {
    enumerable: false,
    value: '<(' + _.map(_.keys(defaultTagsStyles)).join('|') + ')>'
});
Object.defineProperty(defaultTagsStyles, 'getTagsRegexp', {
    enumerable: false,
    value: function () {
        return new RegExp(this.tagsRegexStr, 'g');
    }
});


function applyFilter(filter) {
    var fragment = CKEDITOR.htmlParser.fragment.fromHtml(this._htmlData),
        writer = new CKEDITOR.htmlParser.basicWriter();
    filter.applyTo(fragment);
    fragment.writeHtml(writer);
    var filteredHtml = writer.getHtml();
    this._htmlData = filteredHtml;
    return this;
}

function cleanExternalHtml() {
    var htmlTagsFilter = new CKEDITOR.filter('h1 h2 h3 h4 h5 h6 blockquote p ul ol li br a[href, dataquery]');
    var htmlCommentsFilter = new CKEDITOR.htmlParser.filter({
        comment: function () {
            return false;
        }
    });

    applyFilter.call(this, htmlTagsFilter);
    applyFilter.call(this, htmlCommentsFilter);

    return this;
}

function cleanInternalHtml() {
    //temporarily remove all spans, to prevent nested styles. There is a future task to fix this
    this._htmlData = this._htmlData.replace(/<\/?span.*?>/g, '');
    this._htmlData = this._htmlData.replace(/(<a .*?>.*?<\/a>)/g, function (match, group1) {
        return '<span style="text-decoration:underline">' + group1 + '</span>';
    });
}

function containsList() {
    if (!this._containsList) {
        init.call(this);
    }
    return this._containsList;
}

function fixDefaultThemesForTags() {
    this._htmlData = this._htmlData.replace(defaultTagsStyles.getTagsRegexp(), function (matched, group1) {
        return '<' + group1 + ' class="' + defaultTagsStyles[group1] + '">';
    });
    return this;
}

function fixListChildMustBeLi(htmlData) {
    var fragment = document.createElement('div');
    fragment.innerHTML = htmlData;
    var result = document.createElement('div');
    var nodesArray = Array.prototype.slice.call(fragment.childNodes);

    _.forEach(nodesArray, function (node) {
        if (!node.nodeName || node.nodeName.toLowerCase() !== 'li') {
            var wrapped = document.createElement('li');
            wrapped.appendChild(node);
            result.appendChild(wrapped);
        } else {
            result.appendChild(node);
        }
    });

    return result.innerHTML;
}

function fixListOrphans(node) {
    if (!node || !node.nodeName) {
        return this;
    }
    node.innerHTML = node.innerHTML && fixDefaultThemesForTags.call({_htmlData: node.innerHTML})._htmlData;
    if (node.nodeName.toLowerCase().match(/^(ul|ol)$/)) {
        node.innerHTML = fixListChildMustBeLi.call(this, node.innerHTML);
    } else if (node.nodeName.toLowerCase() === 'li') {
        node.innerHTML = fixOrphans.call(this, node.innerHTML);
    }
    _.forEach(_.toArray(node.childNodes), childNode => fixListOrphans.call(this, childNode));
    return this;
}

function fixListThemes() {
    var frag = document.createElement('div');
    frag.innerHTML = this._htmlData;
    var lists = frag.querySelectorAll('ol, ul');
    if (lists) {
        //for deep nested <ul><li><ol><li><p class="font_8">boo</p...
        //we need to parse starting by innermost list
        //and that's the reason we "reverse()"
        lists = Array.prototype.slice.call(lists).reverse();
        _.forEach(lists, function (list) {
            var classElem = list.querySelector('[class^=font_]');
            var className = classElem && classElem.classList[0] || 'font_8';
            list.className = className;
        });
    }

    this._htmlData = frag.innerHTML;
    return this;
}

function fixOrphans(htmlData) {
    var fragment = document.createElement('div');
    if (htmlData === '') {
        //if empty string return default empty block
        return '<p class="font_8"><span class="wixGuard">' + CONSTASNTS.WIX_GUARD + '</span></p>';
    }

    fragment.innerHTML = _.isUndefined(htmlData) ? this._htmlData : htmlData;
    var result = document.createElement('div');
    var wrapMe = null;
    var nodesArray = Array.prototype.slice.call(fragment.childNodes);

    _.forEach(nodesArray, node => {
        fixListOrphans.call(this, node);
        if (CKEDITOR.dtd.$block[node.nodeName.toLowerCase()]) {
            wrapMe = null;
            result.appendChild(node);
        } else {
            if (!wrapMe) {
                wrapMe = document.createElement('p');
                result.appendChild(wrapMe);
            }
            wrapMe.appendChild(node);
        }
    });
    if (!_.isUndefined(htmlData)) {
        return result.innerHTML;
    }
    reset.call(this, result.innerHTML);
    return this;
}

function fixTextBlocks() {
    if (this.getBlockCount()) {
        this.fixOrphans()
            .trimEmptyLines()
            .fixDefaultThemesForTags()
            .fixListThemes();
    }
    return this;
}

function getBlockCount() {
    if (!this._blockCount) {
        init.call(this);
    }
    return this._blockCount;
}

function getCKDocumentFragment() {
    var tmpDivElem = document.createElement('div');
    tmpDivElem.innerHTML = this._htmlData;
    var fragment = document.createDocumentFragment();
    var nodesArray = Array.prototype.slice.call(tmpDivElem.childNodes);

    _.forEach(nodesArray, function (node) {
        fragment.appendChild(node);
    });
    return new CKEDITOR.dom.documentFragment(fragment);
}

function removeCkBrEol() {
    this._htmlData = this._htmlData.replace(/<br.*?data-cke-eol.*?>/g, '');
    return this;
}

function removeNodeIfEmpty(node, fragment) {
    var isBlock = CKEDITOR.dtd.$block[node.nodeName.toLowerCase()];
    var isEmpty = utils.isWhiteSpace(node.textContent);
    if (isBlock && isEmpty) {
        fragment.removeChild(node);
        return true;
    }
}

function removeElementsByQuerySelector(queryStr) {
    var fragment = document.createElement('div');
    fragment.innerHTML = this._htmlData;
    var elementsToReplace = fragment.querySelectorAll(queryStr);
    _.forEach(elementsToReplace, function (element) {
        var parentNode = element.parentNode;
        while (element.childNodes.length) {
            parentNode.insertBefore(element.childNodes[0], element);
        }
        parentNode.removeChild(element);
    });
    this._htmlData = fragment.innerHTML;
    return this;
}

function removeLinks() {
    throwIfMultiBlock.call(this);
    return removeElementsByQuerySelector.call(this, 'a');
}

function removeUnderlines() {
    throwIfMultiBlock.call(this);
    return removeElementsByQuerySelector.call(this, 'span[style*="text-decoration"]');
}

function reset(htmlData) {
    this._htmlData = htmlData || '';
    this._blockCount = null;
    this._containsList = null;
}

function setHtmlData(htmlData) {
    reset.call(this, htmlData);
}

function textNodesUnder(el) {
    var node,
        result = [],
        walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    while (node = walk.nextNode()) {
        result.push(node);
    }
    return result;
}

function throwIfMultiBlock() {
    if (this.getBlockCount()) {
        throw new Error('implemented for 0 blocks only');
    }
}

function trimEmptyLines() {
    var fragment = document.createElement('div');
    fragment.innerHTML = this._htmlData;
    var nodesArray = Array.prototype.slice.call(fragment.childNodes),
        node, i;
    for (i = 0; i < nodesArray.length; i++) {
        node = nodesArray[i];
        if (!removeNodeIfEmpty(node, fragment)) {
            break;
        }
    }
    nodesArray = Array.prototype.slice.call(fragment.childNodes);
    for (i = nodesArray.length - 1; i >= 0; i--) {
        node = nodesArray[i];
        if (!removeNodeIfEmpty(node, fragment)) {
            break;
        }
    }
    reset.call(this, fragment.innerHTML);
    return this;
}

function unWrapIfSingleBlock() {
    if (getBlockCount.call(this) === 1 && !containsList.call(this)) {
        //explainig the regex
        //1: <([^\s>]*).*?> matches the first opening tag and remembers the tag name
        //2: (.*) will match everithing between the opn and close tag. note that we know for sure that there is such a tag(the only block tag
        //3: <\/\1> matches the closing tag. \1 references the remembered group from step 1
        //4: the replace: $2 is th group from step 2
        reset.call(this, this._htmlData.replace(/<([^\s>]*).*?>(.*)<\/\1>/, '$2'));
    }
    return this;
}

function wrapBlocksInLi() {
    if (!this.getBlockCount()) {
        return this;
    }
    reset.call(this, fixListChildMustBeLi.call(this, this._htmlData));
    return this;
}

function wrapTextNodes(tagName, attributeName, attributeValue) {
    var fragment = document.createElement('div');
    fragment.innerHTML = this._htmlData;
    var textNodes = textNodesUnder(fragment);
    _.forEach(textNodes, function (textNode) {
        var wrapperElement = document.createElement(tagName);
        wrapperElement.setAttribute(attributeName, attributeValue);
        wrapperElement.innerHTML = textNode.textContent;
        var parentElement = textNode.parentNode;
        parentElement.replaceChild(wrapperElement, textNode);
    });
    this._htmlData = fragment.innerHTML;
    return this;
}

function wrapTextNodesInUnderline() {
    throwIfMultiBlock.call(this);
    return wrapTextNodes.call(this, 'span', 'style', 'text-decoration:underline');
}

function wrapTextNodesInATag(dataquery) {
    throwIfMultiBlock.call(this);
    return wrapTextNodes.call(this, 'a', 'dataquery', dataquery);
}

function calculateContainsList(nodesArray) {
    return !!_.find(nodesArray, function (node) {
        return CKEDITOR.dtd.$list[node.nodeName.toLowerCase()];
    });
}

function calculateTextBlockCount(nodesArray) {
    return _.filter(nodesArray, function (node) {
        return CKEDITOR.dtd.$block[node.nodeName.toLowerCase()];
    }).length;
}

function init() {
    if (!this._blockCount) {
        var fragment = document.createElement('div');
        fragment.innerHTML = this._htmlData;
        var nodesArray = Array.prototype.slice.call(fragment.childNodes);
        this._blockCount = calculateTextBlockCount(nodesArray);
        this._containsList = calculateContainsList(nodesArray);
    }
}


function DataTransformer(htmlData, allowList, editor) {
    this._htmlData = htmlData;
    this._blockCount = null;
    this._containsList = null;
    this._editor = editor;

    if (allowList === false) {
        var filter = new CKEDITOR.filter(editor);
        filter.disallow('ul ol li');
        applyFilter.call(this, filter);
    }
}

DataTransformer.prototype = {
    cleanExternalHtml: cleanExternalHtml,
    cleanInternalHtml: cleanInternalHtml,
    containsList: containsList,
    fixDefaultThemesForTags: fixDefaultThemesForTags,
    fixListThemes: fixListThemes,
    fixOrphans: fixOrphans,
    fixTextBlocks: fixTextBlocks,
    getBlockCount: getBlockCount,
    getCKDocumentFragment: getCKDocumentFragment,
    removeCkBrEol: removeCkBrEol,
    removeLinks: removeLinks,
    removeUnderlines: removeUnderlines,
    setHtmlData: setHtmlData,
    trimEmptyLines: trimEmptyLines,
    unWrapIfSingleBlock: unWrapIfSingleBlock,
    wrapBlocksInLi: wrapBlocksInLi,
    wrapTextNodesInUnderline: wrapTextNodesInUnderline,
    wrapTextNodesInATag: wrapTextNodesInATag,
    getHtml: function () {
        return this._htmlData;
    }
};

export default DataTransformer;
